import {useContext, useState} from 'react';
import {Upload, Button} from 'antd';
import {UploadOutlined} from '@ant-design/icons';
import {AuthContext} from 'context/Auth.context';
import {CandidateContext} from 'context/Candidate.context';

const FileUploadField = (props: any) => {
	const [fileList, setFileList] = useState<any>([]);

	const {state} = useContext(CandidateContext);

	const uploadProps = {
		onRemove: (file: any) => {
			setFileList((fileList: any) => {
				const index = fileList.indexOf(file);
				const newFileList = fileList.slice();
				newFileList.splice(index, 1);
				return newFileList;
			});
		},
		beforeUpload: (file: any) => {
			setFileList([file]);
			return false;
		},
		fileList
	};

	return (
		<>
			{(state.statusID === 1 || typeof props.value !== 'string') && (
				<Upload {...props} {...uploadProps}>
					<Button icon={<UploadOutlined />}>Ընտրեք Ֆայլ</Button>
				</Upload>
			)}
			{typeof props.value === 'string' && (
				<a href={process.env.REACT_APP_API_URL + '/' + props.value} target="_blank" rel="noreferrer">
					{props.value.substr(props.value.lastIndexOf('/') + 1)}
				</a>
			)}
		</>
	);
};

export default FileUploadField;
